// const BASE_URL = "http://localhost:8081";
const BASE_URL = "https://server.thebookclub.vishwarajanand.com";
export default BASE_URL;
